module.exports = __webpack_public_path__ + "static/media/youtube.e7fac28d.svg";